// Sidebar.jsx - מעודכן עם onNavigate prop
import React, { useMemo } from "react";
import "../../styles/layout/Sidebar.css";
import { useMamdani } from "../../context/MamdaniContext";

import {
  LayoutDashboard, Bell, FileText, Settings,
  Network, Users, Bot, Route, Share2,
  ShieldAlert, ScanFace, Sparkles, Image,
  Hash, CheckSquare, Shield, Ban, Plug,
  Target, Flag, Download, Activity, ClipboardList,
} from "lucide-react";

function Sidebar({ activePage, onNavigate }) {
  const { mamdaniMode, toggleMode, stats, loading } = useMamdani();

  const sections = useMemo(() => mamdaniMode ? [
    {
      title: "General",
      items: [
        { id: "alerts",        label: "Alerts",           icon: Bell },
        { id: "reports",       label: "Reports",          icon: FileText },
        { id: "targets",       label: "Target Bank",      icon: Target },
        { id: "impersonation", label: "Impersonation",    icon: ShieldAlert },
      ],
    },
    {
      title: "Detection & Analysis",
      items: [
        { id: "deepfake",     label: "Deepfake Detection", icon: ScanFace },
        { id: "listanalysis", label: "List Analysis",      icon: ClipboardList },
      ],
    },
    {
      title: "System",
      items: [
        { id: "settings", label: "Settings", icon: Settings },
      ],
    },
  ] : [
    {
      title: "כללי",
      items: [
        { id: "alerts",    label: "התראות",         icon: Bell },
        { id: "reports",   label: "דוחות",           icon: FileText },
        { id: "targets",   label: "בנק מטרות",      icon: Target },
        { id: "impersonation", label: "זיהוי התחזות", icon: ShieldAlert },
      ],
    },
    {
      title: "ניטור ופעילות",
      items: [
        { id: "botnets",  label: "רשתות בוטים", icon: Network },
        { id: "profiles", label: "פרופילים",     icon: Users },
      ],
    },
    {
      title: "זיהוי וניתוח",
      items: [
        { id: "deepfake",     label: "זיהוי Deepfake", icon: ScanFace },
        { id: "listanalysis", label: "ניתוח רשימות",   icon: ClipboardList },
      ],
    },
    {
      title: "מערכות ותשתיות",
      items: [
        { id: "settings", label: "הגדרות", icon: Settings },
      ],
    },
  ], [mamdaniMode]);

  // פריטים שיש להם קומפוננטה אמיתית
  const IMPLEMENTED = new Set(['dashboard', 'alerts', 'reports', 'targets', 'botnets', 'impersonation', 'profiles', 'deepfake', 'hashtags', 'listanalysis', 'settings']);

  const handleClick = (id) => {
    if (onNavigate) onNavigate(id);
  };

  return (
    <aside className="ab-sidebar" dir={mamdaniMode ? "ltr" : "rtl"}>

      {/* Header */}
      <div className="ab-sidebar-top">
        <div className="ab-sidebar-mode">
          <span className="ab-sidebar-mode-dot" />
          <span className="ab-sidebar-mode-text">{mamdaniMode ? "System Active" : "מערכת פעילה"}</span>
        </div>
        <button className="ab-sidebar-collapse" type="button" aria-label="collapse">
          <Activity size={18} />
        </button>
      </div>

      {/* Mamdani Monitor Button */}
      <div className="ab-mamdani-btn-wrap">
        <button
          className={`ab-mamdani-btn ${mamdaniMode ? 'ab-mamdani-btn--active' : ''}`}
          onClick={toggleMode}
          disabled={loading}
        >
          <span className={`ab-mamdani-dot ${mamdaniMode ? 'ab-mamdani-dot--on' : ''}`} />
          <span className="ab-mamdani-btn-text">
            {mamdaniMode ? 'Mamdani Monitor ON' : 'Mamdani Monitor'}
          </span>
          {mamdaniMode && stats.totalBots > 0 && (
            <span className="ab-mamdani-count">{stats.totalBots}</span>
          )}
        </button>
      </div>

      {/* Menu */}
      <div className="ab-sidebar-scroll">
        {sections.map((section) => (
          <div className="ab-sidebar-section" key={section.title}>
            <div className="ab-sidebar-section-title">{section.title}</div>

            <div className="ab-sidebar-list">
              {section.items.map((item) => {
                const Icon     = item.icon;
                const isActive = activePage === item.id;
                const hasPage  = IMPLEMENTED.has(item.id);

                return (
                  <button
                    key={item.id}
                    type="button"
                    className={`ab-sideitem ${isActive ? "is-active" : ""} ${!hasPage ? "coming-soon" : ""}`}
                    onClick={() => handleClick(item.id)}
                    title={!hasPage ? (mamdaniMode ? "Coming Soon" : "בקרוב") : undefined}
                  >
                    <span className="ab-sideitem-icon" aria-hidden="true">
                      <Icon size={18} />
                    </span>
                    <span className="ab-sideitem-label">{item.label}</span>
                    {!hasPage && <span className="ab-sideitem-soon">{mamdaniMode ? "Soon" : "בקרוב"}</span>}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>

    </aside>
  );
}

export default Sidebar;